<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="12"
        md="12"
      >
        <VMSTitle />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <!-- กรณีไม่มีกล้องทั้งสองตัว แสดงแผนที่ขนาด 6 คอลัมน์ -->
      <b-col
        v-if="!cam1 && !cam2"
        lg="6"
        md="6"
      >
        <VMSMapDetail />
      </b-col>
      <b-col
        v-if="!cam1 && !cam2"
        lg="6"
        md="6"
      >
        <VMSVideoPSD v-if="owner === 'psd'" />
        <VMSVideo v-else />
      </b-col>

      <!-- กรณีมีกล้องตัวใดตัวหนึ่ง แสดงแผนที่เต็มหน้าจอ -->
      <b-col
        v-if="cam1 || cam2"
        lg="12"
        md="12"
      >
        <VMSMapDetail />
      </b-col>
      <b-col
        v-if="cam1 || cam2"
        lg="12"
        md="12"
      >
        <VMSVideoPSD v-if="owner === 'psd'" />
        <VMSVideo v-else />
      </b-col>
    </b-row>
    <br>
    <VMSTable v-if="check" />
    <br>
    <VMSGraph v-if="check" />
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import axios from '@axios'
import VMSTitle from '@/views/vms/detail/VMSTitle.vue'
import VMSMapDetail from '@/views/vms/detail/VMSMapDetail.vue'
import VMSVideo from '@/views/vms/detail/VMSVideo.vue'
import VMSVideoPSD from '@/views/vms/detail/VMSVideoPSD.vue'
import VMSTable from '@/views/vms/detail/VMSTable.vue'
import VMSGraph from '@/views/vms/detail/VMSGraph.vue'

export default {
  components: {
    BRow,
    BCol,
    VMSTitle,
    VMSMapDetail,
    VMSVideo,
    VMSTable,
    VMSGraph,
    VMSVideoPSD,
  },
  data() {
    return {
      check: false,
      owner: '',
      cam1: '',
      cam2: '',
    }
  },
  mounted() {
    this.checkWeather()
    this.getVideo()
  },
  methods: {
    getVideo() {
      axios
        .post('/getMarkerVMSDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.video_vms = response.data[0].video
          this.cam1 = response.data[0].traffic_sign_cam1
          this.cam2 = response.data[0].traffic_sign_cam2
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkWeather() {
      axios
        .post('/checkWeatherCNZ', { wid: this.$route.query.wid })
        .then(response => {
          this.owner = response.data[0].owner
          if (response.data[0].traffic_sign_weather_cnz) {
            this.check = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
